<script>
  export let title = "";
  export let btnStyle = "";
  export let type = "";
  export let px = "5";
  export let me = "0";
  export let href = "";
  export let border_radius = "0.208vw";
  export let padding = "0.625vw 0.833vw";
</script>

<button
  {href}
  class="{btnStyle} me-{me}"
  {type}
  style="border-radius: {border_radius}; padding: {padding}"
  on:click={(e) => {
    if (href !== "") location.href = href;
  }}
>
  <h5 class="m-0 px-{px}  fw-bold">
    {title}
  </h5>
</button>

<style>
  button {
    font-family: "Poppins", sans-serif;
    border-radius: 0.208vw;
  }
  .nav_bar_btn {
    background-color: #ff6d24;
    opacity: 100%;
    font-weight: 800;
    color: white;
    justify-content: center;
    align-items: center;
    display: flex;
    border: none;
  }
  .nav_bar_btn h5 {
    margin: 0;
    font-size: 1.042vw;
    font-weight: 400;
  }
  .submit_btn {
    background-color: white;
    opacity: 100%;
    color: #ff6d24;
    justify-content: center;
    align-items: center;
    display: flex;
    border: none;
  }
  .submit_btn:hover {
    background-color: transparent;
    border: 0.15vw solid white;
    color: white;
  }
  .submit_btn h5 {
    margin: 0;
    font-size: 1.042vw;
    font-weight: 500;
  }
  .nav_bar_btn_mobile {
    background-color: #ff6d24;
    opacity: 100%;
    font-weight: 800;
    color: white;
    justify-content: center;
    align-items: center;
    display: flex;
    border: none;
  }
  .nav_bar_btn_mobile h5 {
    margin: 0;
    font-size: 2.804vw;
    font-weight: 500;
  }
  .submit_btn_mobile {
    background-color: white;
    opacity: 100%;
    color: #ff6d24;
    justify-content: center;
    align-items: center;
    display: flex;
    border: none;
  }
  .submit_btn_mobile:hover {
    background-color: transparent;
    border: 0.15vw solid white;
    color: white;
  }
  .submit_btn_mobile h5 {
    margin: 0;
    font-size: 2.804vw;
    font-weight: 500;
  }
</style>
